export const SUMMARY_GENERATION_LIMIT = 2;
const STORAGE_KEY = "omer-summary-generation-count";

type SummaryStorage = Pick<Storage, "getItem" | "setItem">;

function browserSessionStorage(): SummaryStorage | undefined {
  return typeof window === "undefined" ? undefined : window.sessionStorage;
}

export function createSummaryGenerationLimit(getStorage: () => SummaryStorage | undefined = browserSessionStorage) {
  let memoryCount = 0;

  function count() {
    try {
      const stored = Number(getStorage()?.getItem(STORAGE_KEY) ?? 0);
      if (Number.isSafeInteger(stored) && stored >= 0) {
        memoryCount = Math.max(memoryCount, Math.min(stored, SUMMARY_GENERATION_LIMIT));
      }
    } catch {
      // Keep the limit for this page session when browser storage is unavailable.
    }
    return memoryCount;
  }

  function reserve() {
    if (count() >= SUMMARY_GENERATION_LIMIT) return false;
    memoryCount += 1;
    try {
      getStorage()?.setItem(STORAGE_KEY, String(memoryCount));
    } catch {
      // Storage restrictions must not prevent visitors from using the page.
    }
    return true;
  }

  return { count, reserve };
}

export const summaryGenerationLimit = createSummaryGenerationLimit();
